export default __webpack_public_path__ + "static/media/com-2.1a80a2be.jfif";